import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {
  getValue
} from "../../../../common/src/components/widget/Component";
import Input from "common/src/components/widget/Input";
import {POSITIVE_NUMBER} from "common/src/utils/NumberUtils";

function GuestCard(props) {
  const {t} = useTranslation();
  const [childrenAgeList, setChildrenAgeList] = useState([]);

  useEffect(() => {
    let children = getValue(props.numberOfChildren);
    let ages = getValue(props.age);
    if (ages.length > 0) {
      for (let i = 0; i < ages.length; i++) {
        childrenAgeList[i] = ages[i]
      }
    }
    if (ages.length === 0 && children > 0) {
      for (let i = 0; i < children; i++) {
        childrenAgeList[i] = 0;
      }
    }

    if (+getValue(props.numberOfChildren) !== ages.length) {
      let newChildrenAges = Object.assign(new Array(+getValue(props.numberOfChildren)).fill("0"), childrenAgeList);
      newChildrenAges.splice(+getValue(props.numberOfChildren));
      setChildrenAgeList(newChildrenAges);
    }


  }, [getValue(props.numberOfChildren)])

  useEffect(() => {
    props.age.setValue(childrenAgeList);
  }, [childrenAgeList]);

  const handleAgeChange = index => age => {
    childrenAgeList.splice(index, 1, age);
    setChildrenAgeList([...childrenAgeList]);
    props.age.setValue([...childrenAgeList], undefined, true);
  }

  return (
    <div className="card">
      <header className="card-header">
        <p className="card-header-title">
          <span className="icon fz fz-users medium mr-1"/>
          <span>{t("offer.guest.guests")}</span>
        </p>
      </header>
      <div className="card-content">
        <div className="columns is-multiline has-padding-horizontal">
          <div className="column is-2">
            <Input label={t('offer.guest.number_of_adults')}
                   type="number"
                   min="1"
                   formField={props.numberOfAdults}
                   showArrows={true}
                   numberFormat={POSITIVE_NUMBER}
                   disabled={!props.isEditable}
            />
          </div>
          <div className="column is-2">
            <Input label={t('offer.guest.number_of_children')}
                   type="number"
                   showArrows={true}
                   disabled={!props.isEditable}
                   numberFormat={POSITIVE_NUMBER}
                   formField={props.numberOfChildren}
            />
          </div>
          {childrenAgeList.map((age, index) => (
            <div className="column is-2" key={index}>
              <div>
                <Input label={t('offer.guest.age')}
                       type="number"
                       value={age}
                       showArrows={true}
                       numberFormat={POSITIVE_NUMBER}
                       disabled={!props.isEditable}
                       min="1"
                       max="18"
                       onChange={handleAgeChange(index)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GuestCard;
